import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'cdp-fe-commons-layout/dist/cdp-fe-commons-layout.css'
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';
import 'bootstrap-italia/dist/bootstrap-italia.esm';
import 'formiojs/dist/formio.full.min.css';
import {createPinia} from "pinia";
import {useLoadingSpinnerStore} from "@/stores/loadingSpinner";
import axios from "./Api";
import {useNotificationStore} from "@/stores/notification";
import {INotification} from "@/interfaces/components/general/INotification";
import {NotificationStatus} from "@/enums/components/general/NotificationStatus";
import {NotificationPosition} from "@/enums/components/general/NotificationPosition";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/v4-shims.css';
import { useServiceDetailStore } from "@/stores/service/serviceDetail";
import enMessages from "@/locales/en.json";
import itMessages from "@/locales/it.json";

import 'flatpickr/dist/flatpickr.min.css'

// @ts-ignore
import cdp_fe_commons_layout, {IOptions} from 'cdp-fe-commons-layout'
// @ts-ignore
import {Collapse, Dropdown, NavScroll} from "bootstrap-italia";
import {useUserStore} from "@/stores/user";
// @ts-ignore
import i18n from "./i18n"

const pinia = createPinia();
export const app = createApp(App)
app.use(pinia)
app.use(i18n)

const loadingSpinnerStore = useLoadingSpinnerStore();

const notificationStore = useNotificationStore();
const serviceDetailStore = useServiceDetailStore();
const crashManager = (error: string) => {
    const language = serviceDetailStore.language || 'en';
    const messages = language === 'it' ? itMessages : enMessages;
    notificationStore.addNotification({
        title: messages.crashManager.title,
        message: messages.crashManager.message,
        status: NotificationStatus.ERROR,
        position: NotificationPosition.TOP,
        timeout: 1500,
        dismissable: true,
        afterDismissCallback: () => {
            console.error(error);
            loadingSpinnerStore.stopAllLoading();
            router.push("/");
        }
    } as INotification)
};

const unauthorizedManager = (error: string) => {
    /*
    notificationStore.addNotification({
        title: "Accesso non consentito",
        message: "Per proseguire è necessario autenticarsi tramite spid",
        status: NotificationStatus.ERROR,
        position: NotificationPosition.TOP,
        timeout: 1500,
        dismissable: true,
        afterDismissCallback: () => {
            console.error(error);
            loadingSpinnerStore.stopAllLoading();
            location.href = process.env.VUE_APP_SERVER_SPID
            //router.push("/servizi");
        }
    } as INotification)
     */
    const userStore = useUserStore()
    userStore.logout()
};


app.use(cdp_fe_commons_layout, {router: router, Dropdown: Dropdown, Collapse: Collapse, NavScroll: NavScroll} as IOptions)
app.use(axios, {
    startLoader: loadingSpinnerStore.startLoading,
    stopLoader: loadingSpinnerStore.stopLoading,
    crashManager: crashManager,
    unauthorizedManager: unauthorizedManager
})
app.use(router)
app.mount('#app');



